import { z } from 'zod'
import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { Button } from 'components/ui/button'
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from 'components/ui/form'
import { Input } from 'components/ui/input'
import {
  Sheet,
  SheetClose,
  SheetContent,
  SheetDescription,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from 'components/ui/sheet'
import { showSubmittedData } from 'helpers/show-submitted-data'
import { useAppDispatch } from 'store/store'
import { runAsyncJob } from 'store/updateTasks/updateTaskSlice'

interface Props {
  open: boolean
  onOpenChange: (open: boolean) => void
}

const formSchema = z.object({
  job_name: z.string().min(1, 'Title is required.'),
  model_param: z
    .object({
      _model: z.string().min(1, 'Please select a model.').optional(),
      id: z.string().min(1, 'Please select a model.').optional(),
    })
    .optional(),
})
type TasksForm = z.infer<typeof formSchema>

export function TasksMutateDrawer({ open, onOpenChange }: Props) {
  const dispatch = useAppDispatch()
  const form = useForm<TasksForm>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      job_name: '',
    },
  })

  const onSubmit = (data: TasksForm) => {
    // do something with the form data
    dispatch(runAsyncJob(data))
    onOpenChange(false)
    form.reset()
    showSubmittedData(data)
  }

  return (
    <Sheet
      open={open}
      onOpenChange={(v) => {
        onOpenChange(v)
        form.reset()
      }}
    >
      <SheetContent className='flex flex-col'>
        <SheetHeader className='text-left'>
          <SheetTitle>Lancia Async Job</SheetTitle>
          <SheetDescription>
            Fai partire job asincrono dato il suo nome, con o senza parametri.
          </SheetDescription>
        </SheetHeader>
        <Form {...form}>
          <form
            id='tasks-form'
            onSubmit={form.handleSubmit(onSubmit)}
            className='flex-1 space-y-5 px-4'
          >
            <FormField
              control={form.control}
              name='job_name'
              render={({ field }) => (
                <FormItem className='space-y-1'>
                  <FormLabel>Nome Job</FormLabel>
                  <FormControl>
                    <Input {...field} placeholder='Nome del job in rails' />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name='model_param._model'
              render={({ field }) => (
                <FormItem className='space-y-1'>
                  <FormLabel>Model</FormLabel>
                  <FormControl>
                    <Input {...field} placeholder='Seleziona un modello' />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
            <FormField
              control={form.control}
              name='model_param.id'
              render={({ field }) => (
                <FormItem className='space-y-1'>
                  <FormLabel>Model ID</FormLabel>
                  <FormControl>
                    <Input {...field} placeholder='Inserisci ID del modello' />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />
          </form>
        </Form>
        <SheetFooter className='gap-2'>
          <SheetClose asChild>
            <Button variant='outline'>Close</Button>
          </SheetClose>
          <Button form='tasks-form' type='submit'>
            Lancia Job
          </Button>
        </SheetFooter>
      </SheetContent>
    </Sheet>
  )
}
